import { routerMiddleware } from "connected-react-router";
import { AnyAction, applyMiddleware, compose, createStore } from "redux";
import thunk, { ThunkAction, ThunkMiddleware } from "redux-thunk";
import history from "./history";
import app from "./reducers";

const store = createStore(app, compose(applyMiddleware(thunk as ThunkMiddleware<any, AnyAction>, routerMiddleware(history))));

export type AppStore = typeof store;
export type AppState = ReturnType<AppStore["getState"]>;

export type AppGetState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
export type ThunkResult<R> = ThunkAction<R, AppState, undefined, AnyAction>;

export default store;



// WEBPACK FOOTER //
// ./src/redux/index.ts